import { call, put, takeLatest } from 'redux-saga/effects'
import { AuthType, setAuth, setAuthUser } from '@root-gipro/store/actions'
import { loginApi, authorizeApi, logoutApi, giproApp } from '@root-gipro/store/api'
import store from '@root-gipro/store'

// --- Утилита очистки авторизационной информации ---
function clearAuthStorage() {
	localStorage.removeItem('access_token')
	localStorage.removeItem('firstname')
	localStorage.removeItem('lastname')
	localStorage.removeItem('userId')
	localStorage.removeItem('roleId')
	localStorage.removeItem('companyId')
	localStorage.removeItem('filialId')
	delete giproApp.defaults.headers['Authorization']
}

function* login(action: { type: string; login: string; password: string }) {
	try {
		const loginRes = yield call(loginApi, action.login, action.password)

		if (loginRes && loginRes.access_token) {
			const { access_token, expires_in, refresh_token } = loginRes

			yield put(setAuth(access_token, expires_in, refresh_token))
			localStorage.setItem('access_token', access_token)
			localStorage.setItem('refresh_token', refresh_token)
			giproApp.defaults.headers['Authorization'] = `Bearer ${access_token}`

			const authRes = yield call(authorizeApi, loginRes.access_token)
			if (authRes && authRes.user) {
				const user = authRes.user

				yield put(
					setAuthUser({
						roleId: user.roleId,
						id: user.id,
						firstname: user.firstname,
						lastname: user.lastname,
					})
				)

				localStorage.setItem('firstname', user.firstname)
				localStorage.setItem('lastname', user.lastname)
				localStorage.setItem('userId', String(user.id))
				localStorage.setItem('roleId', String(user.roleId))
				localStorage.setItem('companyId', String(user.companyId))
				localStorage.setItem('filialId', String(user.filialId))
			}
		}
	} catch (error) {
		console.error('Login error:', error)
		clearAuthStorage()
	}
}
function* authorize() {
	try {
		const access_token = localStorage.getItem('access_token')
		if (!access_token) return

		giproApp.defaults.headers['Authorization'] = `Bearer ${access_token}`

		const response = yield call(authorizeApi, access_token)

		if (response && response.user) {
			const user = response.user

			yield put(
				setAuthUser({
					roleId: user.roleId,
					id: user.id,
					firstname: user.firstname,
					lastname: user.lastname,
				})
			)

			localStorage.setItem('firstname', user.firstname)
			localStorage.setItem('lastname', user.lastname)
			localStorage.setItem('userId', String(user.id))
			localStorage.setItem('roleId', String(user.roleId))
			localStorage.setItem('companyId', String(user.companyId))
			localStorage.setItem('filialId', String(user.filialId))
		}
	} catch (error) {
		console.error('Authorize error:', error)
		clearAuthStorage()
	}
}

function* logout() {
	try {
		const refresh_token = localStorage.getItem('refresh_token')		
		const response = yield call(logoutApi,  refresh_token || '')
		if (response && response.status === 'success') {
			clearAuthStorage()
		}else{
			clearAuthStorage()
		}
	} catch (error) {
		console.error('Logout error:', error)
		clearAuthStorage()
	}
}

export default function* authSaga() {
	yield takeLatest(AuthType.LOGIN, login)
	yield takeLatest(AuthType.AUTHORIZE, authorize)
	yield takeLatest(AuthType.LOGOUT, logout)
}
